import { render } from "./MotifBackdrop.vue?vue&type=template&id=f8960e1a&scoped=true"
import script from "./MotifBackdrop.vue?vue&type=script&lang=js"
export * from "./MotifBackdrop.vue?vue&type=script&lang=js"

import "./MotifBackdrop.vue?vue&type=style&index=0&id=f8960e1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8960e1a"]])

export default __exports__